/**
 * Takes a string, returns string with first character uppercased.
 */
export const capitalize = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
